import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.css'],
    standalone: false
})
export class SpinnerComponent implements OnInit {
  @Input() sizePx = 20;
  @Input() strokeWidthPx = 3;
  @Input() accentColor = '#5b47fb';
  @Input() trackColor = '#e5e7eb';

  constructor() { }

  ngOnInit(): void {
  }

}
